/**
 * Bản đồ hành chính Việt Nam sau sáp nhập tỉnh (Nghị quyết 202/2025/QH15)
 * Có hiệu lực từ ngày 12/06/2025
 * Cả nước có 34 đơn vị hành chính cấp tỉnh, gồm 28 tỉnh và 6 thành phố trực thuộc Trung ương
 */
const mapIdToName = {
    // 1. Tuyên Quang (Hà Giang + Tuyên Quang cũ)
    VNM457: {
        name: "Tuyên Quang"
    },
    VNM512: {
        name: "Tuyên Quang" // Hà Giang sáp nhập vào Tuyên Quang
    },
    
    // 2. Cao Bằng (giữ nguyên)
    VNM511: {
        name: "Cao Bằng"
    },
    
    // 3. Lai Châu (giữ nguyên)
    VNM453: {
        name: "Lai Châu"
    },
    
    // 4. Lào Cai (Lào Cai + Yên Bái)
    VNM5483: {
        name: "Lào Cai"
    },
    VNM458: {
        name: "Lào Cai" // Yên Bái sáp nhập vào Lào Cai
    },
    
    // 5. Thái Nguyên (Bắc Kạn + Thái Nguyên)
    VNM452: {
        name: "Thái Nguyên"
    },
    VNM451: {
        name: "Thái Nguyên" // Bắc Kạn sáp nhập vào Thái Nguyên
    },
    
    // 6. Điện Biên (giữ nguyên)
    VNM450: {
        name: "Điện Biên"
    },
    
    // 7. Lạng Sơn (giữ nguyên)
    VNM454: {
        name: "Lạng Sơn"
    },
    
    // 8. Sơn La (giữ nguyên)
    VNM455: {
        name: "Sơn La"
    },
    
    // 9. Phú Thọ (Hòa Bình + Vĩnh Phúc + Phú Thọ)
    VNM469: {
        name: "Phú Thọ"
    },
    VNM459: {
        name: "Phú Thọ" // Hòa Bình sáp nhập vào Phú Thọ
    },
    VNM464: {
        name: "Phú Thọ" // Vĩnh Phúc sáp nhập vào Phú Thọ
    },
    
    // 10. Bắc Ninh (Bắc Giang + Bắc Ninh)
    VNM463: {
        name: "Bắc Ninh"
    },
    VNM470: {
        name: "Bắc Ninh" // Bắc Giang sáp nhập vào Bắc Ninh
    },
    
    // 11. Quảng Ninh (giữ nguyên)
    VNM429: {
        name: "Quảng Ninh"
    },
    
    // 12. TP. Hà Nội (giữ nguyên)
    VNM462: {
        name: "TP. Hà Nội"
    },
    
    // 13. TP. Hải Phòng (Hải Dương + TP. Hải Phòng)
    VNM4600: {
        name: "TP. Hải Phòng"
    },
    VNM460: {
        name: "TP. Hải Phòng" // Hải Dương sáp nhập vào Hải Phòng
    },
    
    // 14. Hưng Yên (Thái Bình + Hưng Yên)
    VNM461: {
        name: "Hưng Yên"
    },
    VNM471: {
        name: "Hưng Yên" // Thái Bình sáp nhập vào Hưng Yên
    },
    
    // 15. Ninh Bình (Hà Nam + Ninh Bình + Nam Định)
    VNM466: {
        name: "Ninh Bình"
    },
    VNM467: {
        name: "Ninh Bình" // Hà Nam sáp nhập vào Ninh Bình
    },
    VNM468: {
        name: "Ninh Bình" // Nam Định sáp nhập vào Ninh Bình
    },
    
    // 16. Thanh Hóa (giữ nguyên)
    VNM456: {
        name: "Thanh Hóa"
    },
    
    // 17. Nghệ An (giữ nguyên)
    VNM475: {
        name: "Nghệ An"
    },
    
    // 18. Hà Tĩnh (giữ nguyên)
    VNM474: {
        name: "Hà Tĩnh"
    },
    
    // 19. Quảng Trị (Quảng Bình + Quảng Trị)
    VNM489: {
        name: "Quảng Trị"
    },
    VNM476: {
        name: "Quảng Trị" // Quảng Bình sáp nhập vào Quảng Trị
    },
    
    // 20. TP. Huế (giữ nguyên)
    VNM490: {
        name: "TP. Huế"
    },
    
    // 21. TP. Đà Nẵng (Quảng Nam + TP. Đà Nẵng)
    VNM491: {
        name: "TP. Đà Nẵng"
    },
    VNM487: {
        name: "TP. Đà Nẵng" // Quảng Nam sáp nhập vào Đà Nẵng
    },
    
    // 22. Quảng Ngãi (Quảng Ngãi + Kon Tum)
    VNM488: {
        name: "Quảng Ngãi"
    },
    VNM486: {
        name: "Quảng Ngãi" // Kon Tum sáp nhập vào Quảng Ngãi
    },
    
    // 23. Gia Lai (Gia Lai + Bình Định)
    VNM478: {
        name: "Gia Lai"
    },
    VNM485: {
        name: "Gia Lai" // Bình Định sáp nhập vào Gia Lai
    },
    
    // 24. Đắk Lắk (Phú Yên + Đắk Lắk)
    VNM477: {
        name: "Đắk Lắk"
    },
    VNM482: {
        name: "Đắk Lắk" // Phú Yên sáp nhập vào Đắk Lắk
    },
    
    // 25. Khánh Hòa (Khánh Hòa + Ninh Thuận)
    VNM479: {
        name: "Khánh Hòa"
    },
    VNM481: {
        name: "Khánh Hòa" // Ninh Thuận sáp nhập vào Khánh Hòa
    },
    
    // 26. Lâm Đồng (Đắk Nông + Lâm Đồng + Bình Thuận)
    VNM480: {
        name: "Lâm Đồng"
    },
    VNM4835: {
        name: "Lâm Đồng" // Đắk Nông sáp nhập vào Lâm Đồng
    },
    VNM496: {
        name: "Lâm Đồng" // Bình Thuận sáp nhập vào Lâm Đồng
    },
    
    // 27. Đồng Nai (Bình Phước + Đồng Nai)
    VNM497: {
        name: "Đồng Nai"
    },
    VNM484: {
        name: "Đồng Nai" // Bình Phước sáp nhập vào Đồng Nai
    },
    
    // 28. Tây Ninh (Long An + Tây Ninh)
    VNM444: {
        name: "Tây Ninh"
    },
    VNM503: {
        name: "Tây Ninh" // Long An sáp nhập vào Tây Ninh
    },
    
    // 29. TP. Hồ Chí Minh (Bình Dương + TPHCM + Bà Rịa - Vũng Tàu)
    VNM501: {
        name: "TP. Hồ Chí Minh"
    },
    VNM483: {
        name: "TP. Hồ Chí Minh" // Bình Dương sáp nhập vào TPHCM
    },
    VNM495: {
        name: "TP. Hồ Chí Minh" // Bà Rịa - Vũng Tàu sáp nhập vào TPHCM
    },
    
    // 30. Đồng Tháp (Tiền Giang + Đồng Tháp)
    VNM500: {
        name: "Đồng Tháp"
    },
    VNM4834: {
        name: "Đồng Tháp" // Tiền Giang sáp nhập vào Đồng Tháp
    },
    
    // 31. An Giang (Kiên Giang + An Giang)
    VNM498: {
        name: "An Giang"
    },
    VNM502: {
        name: "An Giang" // Kiên Giang sáp nhập vào An Giang
    },
    
    // 32. Vĩnh Long (Bến Tre + Vĩnh Long + Trà Vinh)
    VNM510: {
        name: "Vĩnh Long"
    },
    VNM504: {
        name: "Vĩnh Long" // Bến Tre sáp nhập vào Vĩnh Long
    },
    VNM509: {
        name: "Vĩnh Long" // Trà Vinh sáp nhập vào Vĩnh Long
    },
    
    // 33. TP. Cần Thơ (Sóc Trăng + Hậu Giang + TP. Cần Thơ)
    VNM499: {
        name: "TP. Cần Thơ"
    },
    VNM508: {
        name: "TP. Cần Thơ" // Sóc Trăng sáp nhập vào Cần Thơ
    },
    VNM505: {
        name: "TP. Cần Thơ" // Hậu Giang sáp nhập vào Cần Thơ
    },
    
    // 34. Cà Mau (Bạc Liêu + Cà Mau)
    VNM507: {
        name: "Cà Mau"
    },
    VNM506: {
        name: "Cà Mau" // Bạc Liêu sáp nhập vào Cà Mau
    }
}

/**
 * Trả về danh sách tất cả id thuộc cùng một tỉnh (tỉnh sáp nhập có nhiều id).
 * @param {string} provinceName - Tên tỉnh (vd: "Tuyên Quang")
 * @returns {string[]} Mảng id (vd: ["VNM457", "VNM512"])
 */
const getIdsByProvinceName = (provinceName) => {
    if (!provinceName) return [];
    const ids = [];
    for (const id in mapIdToName) {
        if (mapIdToName[id].name === provinceName) ids.push(id);
    }
    return ids;
};

/**
 * Danh sách 34 tỉnh/thành (không trùng lặp), sắp xếp theo alphabet tiếng Việt.
 * @returns {{ name: string, id: string }[]}
 */
const getProvinceList = () => {
    const seen = {};
    const provinces = [];
    for (const id in mapIdToName) {
        const name = mapIdToName[id].name;
        if (!name || seen[name]) continue;
        seen[name] = true;
        provinces.push({ name, id });
    }
    const sortKey = (name) => name.replace(/^TP\.\s*/i, '');
    provinces.sort((a, b) => sortKey(a.name).localeCompare(sortKey(b.name), 'vi', { sensitivity: 'base' }));
    return provinces;
};

module.exports = mapIdToName
module.exports.getIdsByProvinceName = getIdsByProvinceName;
module.exports.getProvinceList = getProvinceList;
